import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import {PanierService} from "../../../services/manage/panier/panier.service";
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";





@Component({
  selector: 'app-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.css']
})
export class CancelOrderComponent implements OnInit {
  innerHeight: number = window.innerHeight;
  interval: any;


  timeSec = 20;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<CancelOrderComponent>,
    private tools: ToolsService,
    private authService: AuthService,

  ) {



  }

  ngOnInit(): void {


    if (this.tools.checkCurrentPage("endorder") || this.tools.checkCurrentPage("product")) {


      this.interval = setInterval(() => {

        if (this.timeSec > 0) {
          this.timeSec -= 1;
        }

        if (this.timeSec == 0 && this.interval) {
          clearInterval(this.interval);
          this.interval = null;
          this.remove_order("interval");

        }


      }, 1000);
    }
    else {

      this.closeDial();
    }



  }




  //annulation vide le localstorage
  remove_order(data?: any) {


    this.authService.logOut();

    this.tools.removeStor("date_order");
    this.tools.removeStor("hour_order");
    this.tools.removeStor(SalemethodService.TAG_STORAGE);
    this.tools.removeStor(PanierService.TAG_STORAGE);

    this.tools.removeStor("payment_save_order");
    this.tools.removeStor("payment_save_order_stripe");
    this.tools.removeStor("credit_fid");
    this.tools.removeStor("alcool_check");
    this.tools.removeStor("lang");

    this.closeDial("reset");

  }


  //reset set intervall
  closeDial(data?: any) {



    clearInterval(this.interval);
    this.interval = null;

     this.dialogRef.close(data);
  }

}
